export default __webpack_public_path__ + "static/media/manorama_max_logo_dark_bg.58cd6d52.png";